import { LL } from "../Routes";

export const Upcoming = () => {
	window.location.replace(LL("/premium-streams"));
	return null;
}

export default Upcoming;